import {useBatchVideoSupport} from '../../../../../../service/company/company-hook';
import {SkippedCompanyType} from '../../../../../../service/company/company-type';
import {
    CompanyGalleryImageType,
    hasUploadedCompanyVideo,
} from '../../../../../../service/company-v2/types/company-gallery-type';

const NO_SKIPPED_COMPANIES: Array<SkippedCompanyType> = [];

type ResultType = {
    /** A video was uploaded in this session; saved videos do not count. */
    hasNewVideo: boolean;
    /** The company, if the video uploaded now would not reach Yandex; empty while unknown. */
    skippedCompanies: Array<SkippedCompanyType>;
};

/**
 * Whether a video uploaded in the company card will reach Yandex. Asked once a video is uploaded, not on every open
 * of the card; a new company (id 0) has nothing to ask about.
 */
export function useGalleryVideoSupport(
    companyId: number,
    gallery: Array<CompanyGalleryImageType> | undefined
): ResultType {
    const hasNewVideo = hasUploadedCompanyVideo(gallery ?? []);
    const {data} = useBatchVideoSupport(companyId > 0 && hasNewVideo ? {selected_ids: [companyId]} : null, {});

    return {hasNewVideo, skippedCompanies: data?.skipped ?? NO_SKIPPED_COMPANIES};
}
